import AuthService from '@/modules/auth/services/auth.service';
const user = JSON.parse(localStorage.getItem('user'));
const type = JSON.parse(localStorage.getItem('type'));
const consultant = JSON.parse(localStorage.getItem('consultant'));
const is_belong_to_alliacne = JSON.parse(localStorage.getItem('is_belong_to_alliacne'));
const is_alliance_leader = JSON.parse(localStorage.getItem('is_alliance_leader'));
const initialState = user ? { loggedIn: true, user, type, consultant, is_belong_to_alliacne, is_alliance_leader } : { loggedIn: false, user: null, type: null, consultant: null, is_belong_to_alliacne: null, is_alliance_leader: null };
initialState.permissions = [];
export const auth = {
    namespaced: true,
    state: initialState,
    getters: {
        str_per(state) {
            return state.permissions.toString()
        }
    },
    actions: {
        login({ commit }, user) {
            return AuthService.login(user).then(
                user => {
                    commit('loginSuccess', user);
                    return Promise.resolve(user);
                },
                error => {
                    commit('loginFailure');
                    return Promise.reject(error);
                }
            );
        },
        loginOtp({ commit }, user) {
            return AuthService.login_otp(user).then(
                user => {
                    return Promise.resolve(user);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        logout({ commit }) {
            AuthService.logout();
            commit('logout');
        },
        register({ commit }, user) {
            return AuthService.register(user).then(
                response => {
                    commit('registerSuccess');
                    return Promise.resolve(response.data);
                },
                error => {
                    // alert('registerFailure');
                    commit('registerFailure');
                    return Promise.reject(error);
                }
            );
        },
        getPermission({ commit }) {
            return AuthService.permission(user).then(
                response => {
                    commit('setPermission', response.data.permissions);
                    return Promise.resolve(response.data);
                },
                error => {
                    // alert('registerFailure');
                    return Promise.reject(error);
                }
            );
        }
    },
    mutations: {
        setPermission(state, data) {
            state.permissions = data
        },
        setSigneture(state, data) {
            state.user.signature = data
        },
        setStamp(state, data) {
            state.user.stamp = data
        },
        loginSuccess(state, user) {
            state.loggedIn = true;
            state.user = user.user;
            state.type = user.type;
            state.consultant = user.consultant;
            state.is_alliance_leader = user.is_alliance_leader;
            state.is_belong_to_alliacne = user.is_belong_to_alliacne
        },
        loginFailure(state) {
            state.loggedIn = false;
            state.user = null;
            state.type = null;
            state.consultant = null;
            state.is_alliance_leader = null
            state.is_belong_to_alliacne = null
        },
        logout(state) {
            state.loggedIn = false;
            state.user = null;
            state.type = null;
            state.consultant = null;
            state.is_alliance_leader = null
            state.is_belong_to_alliacne = null
            state.permissions = [];
        },
        registerSuccess(state) {
            state.loggedIn = false;
        },
        registerFailure(state) {
            state.loggedIn = false;
        }
    },
};